import React, { useState, useEffect } from "react";
import { Drawer } from "@mui/material";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import moment from "moment";

import { selectModelId } from "features/Model/_ducks/selectors";
import { actions as modelActions } from "features/Model/_ducks";

import { useOutsideClickHook } from "utils/outsideClick";

import SortDropdown from "./SortDropdown";
import VersionEntry from "./VersionEntry";

import classes from "./styles.module.scss";

import { default as ArrowDown } from "assets/images/icons/JSX/arrow-down";

const { getAllHistoricalModels } = modelActions;

const sortVersionHistoryByDate = (versionHistory = {}, sortValue = "newest") => {
    const sortDirection = sortValue === "oldest" ? 1 : -1;

    return Object.entries(versionHistory)
        .sort(([dateA], [dateB]) => {
            return sortDirection * (new Date(dateA) - new Date(dateB));
        })
        .map(([date, version]) => ({
            ...version,
            date,
        }));
};

const VersionControlDrawer = ({ modelId, getAllHistoricalModels, isOpen, close }) => {
    const [sortOption, setSortOption] = useState({ value: "newest", label: "Newest" });
    const [isSortDropdownOpen, setIsSortDropdownOpen] = useState(false);
    const [versionHistory, setVersionHistory] = useState({});
    const [sortedVersionHistory, setSortedVersionHistory] = useState([]);

    useEffect(() => {
        (async () => {
            const data = await getAllHistoricalModels(modelId);
            setVersionHistory(data);
        })();
    }, [getAllHistoricalModels, modelId]);

    useEffect(() => {
        setSortedVersionHistory(sortVersionHistoryByDate(versionHistory, sortOption.value));
    }, [sortOption.value, versionHistory]);

    // useEffect(() => {
    //     console.log(sortedVersionHistory);
    // }, [sortedVersionHistory]);

    const sortDropdownRef = useOutsideClickHook(() => {
        setIsSortDropdownOpen(false);
    });

    const onClose = () => {
        close();
    };

    return (
        <Drawer open={isOpen} onClose={onClose} anchor="right" classes={{ paper: classes.versionControlDrawerPaper }}>
            <div className={classes.versionControlHeaderContainer}>
                <h2>Version History</h2>
            </div>
            <div className={classes.versionControlFiltersContainer}>
                <div
                    onClick={() => setIsSortDropdownOpen(!isSortDropdownOpen)}
                    ref={sortDropdownRef}
                    className={classes.versionControlFilterSortBy}
                >
                    <span>{sortOption.label}</span>
                    <ArrowDown
                        className={`${classes.versionControlFilterSortByArrow} ${isSortDropdownOpen && classes.open}`}
                        fill="#646F81"
                    />
                </div>
                <SortDropdown
                    open={isSortDropdownOpen}
                    close={() => setIsSortDropdownOpen(false)}
                    setSortOption={setSortOption}
                    sortOption={sortOption}
                />
            </div>
            <div className={classes.versionControlHistoryContainer}>
                {sortedVersionHistory.map((version) => (
                    <VersionEntry key={version.date} {...version} closeDrawer={onClose} />
                ))}
            </div>
        </Drawer>
    );
};

const mapStateToProps = createStructuredSelector({
    modelId: selectModelId,
});

const mapDispatchToProps = (dispatch) => ({
    getAllHistoricalModels: (modelId) => dispatch(getAllHistoricalModels(modelId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(VersionControlDrawer);
